import {
    Ratchet,
    RatchetModel,
    RatchetModels,
    RatchetModelsEnum
} from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

export const PRIME_COMBINED_CONVERSION_WMG = 'PRIME_COMBINED_CONVERSION_WMG';
export const PRIME_COMBINED_CONVERSION_UMG = 'PRIME_COMBINED_CONVERSION_UMG';

export const COMBINED_PRIME_WMG_CONVERSION_MODELS = [
    RatchetModelsEnum.PRIME_PRIMARY_CONVERSION_WMG,
    RatchetModelsEnum.PRIME_SECONDARY_CONVERSION_WMG,
    RatchetModelsEnum.PRIME_SECONDARY_CONVERSION_WMG_GUARDRAIL,
    RatchetModelsEnum.PRIME_TERTIARY_CONVERSION_WMG
];

export const COMBINED_PRIME_UMG_FLOOR_CONVERSION_MODELS = [
    RatchetModelsEnum.PRIME_CONVERSION_FLOOR_UMG,
    RatchetModelsEnum.PRIME_CONVERSION_FLOOR_UMG_GUARDRAIL
];

export const generateRatchetModelsWithThresholds = (ratchetModels: RatchetModel[]) => {
    return ratchetModels.map(
        (ratchetModel): RatchetModel => ({
            ratchetModelId: ratchetModel.ratchetModelId,
            ratchetModel: ratchetModel.ratchetModel,
            description: ratchetModel.description,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ratchets: conversionModelsThresholdsMap[ratchetModel.ratchetModel!],
            ratchetDefinitions: ratchetModel.ratchetDefinitions
        })
    );
};

export const conversionModelsThresholdsMap: Record<string, Ratchet[]> = {
    [RatchetModelsEnum.PRIME_CONVERSION_SONY]: [
        {
            threshold: 0.25,
            thresholdOperator: '<='
        },
        {
            threshold: 0.35,
            thresholdOperator: '<='
        },
        {
            threshold: 0.45,
            thresholdOperator: '<='
        },
        {
            threshold: 0.55,
            thresholdOperator: '<='
        }
    ],
    [RatchetModelsEnum.PRIME_CONVERSION_ORCHARD]: [
        {
            threshold: 0.25,
            thresholdOperator: '<='
        },
        {
            threshold: 0.35,
            thresholdOperator: '<='
        },
        {
            threshold: 0.45,
            thresholdOperator: '<='
        },
        {
            threshold: 0.55,
            thresholdOperator: '<='
        }
    ],
    [RatchetModelsEnum.PRIME_PRIMARY_CONVERSION_WMG]: [
        {
            threshold: 0.15,
            thresholdOperator: '<'
        },
        {
            threshold: 0.25,
            thresholdOperator: '<'
        },
        {
            threshold: 0.35,
            thresholdOperator: '<'
        }
    ],
    [RatchetModelsEnum.PRIME_SECONDARY_CONVERSION_WMG]: [
        {
            threshold: 0.15,
            thresholdOperator: '<'
        },
        {
            threshold: 0.25,
            thresholdOperator: '<'
        },
        {
            threshold: 0.35,
            thresholdOperator: '<'
        }
    ],
    [RatchetModelsEnum.PRIME_SECONDARY_CONVERSION_WMG_GUARDRAIL]: [
        {
            threshold: 0.15,
            thresholdOperator: '<'
        },
        {
            threshold: 0.25,
            thresholdOperator: '<'
        },
        {
            threshold: 0.35,
            thresholdOperator: '<'
        }
    ],
    [RatchetModelsEnum.PRIME_TERTIARY_CONVERSION_WMG]: [
        {
            threshold: 0.15,
            thresholdOperator: '<'
        },
        {
            threshold: 0.25,
            thresholdOperator: '<'
        },
        {
            threshold: 0.35,
            thresholdOperator: '<'
        },
        {
            threshold: 1,
            thresholdOperator: '<'
        }
    ],
    [RatchetModelsEnum.PRIME_CONVERSION_UMG]: [
        {
            threshold: -0.2,
            thresholdOperator: '<='
        },
        {
            threshold: -0.1,
            thresholdOperator: '<='
        },
        {
            threshold: 0.1,
            thresholdOperator: '><'
        },
        {
            threshold: 0.1,
            thresholdOperator: '>='
        },
        {
            threshold: 0.2,
            thresholdOperator: '>='
        }
    ],
    [RatchetModelsEnum.PRIME_CONVERSION_FLOOR_UMG]: [
        {
            threshold: -0.2,
            thresholdOperator: '<='
        },
        {
            threshold: -0.1,
            thresholdOperator: '<='
        },
        {
            threshold: 0.1,
            thresholdOperator: '><'
        },
        {
            threshold: 0.1,
            thresholdOperator: '>='
        },
        {
            threshold: 0.2,
            thresholdOperator: '>='
        }
    ],
    [RatchetModelsEnum.PRIME_CONVERSION_FLOOR_UMG_GUARDRAIL]: [
        {
            threshold: -0.2,
            thresholdOperator: '<='
        },
        {
            threshold: -0.1,
            thresholdOperator: '<='
        },
        {
            threshold: 0.1,
            thresholdOperator: '><'
        },
        {
            threshold: 0.1,
            thresholdOperator: '>='
        },
        {
            threshold: 0.2,
            thresholdOperator: '>='
        }
    ],
    [RatchetModelsEnum.AMF_CONVERSION_UMG]: [
        {
            threshold: 0.1,
            thresholdOperator: '<'
        },
        {
            threshold: 0.19,
            thresholdOperator: '<'
        },
        {
            threshold: 0.29,
            thresholdOperator: '<'
        }
    ],
    [RatchetModelsEnum.AMF_CONVERSION_ORCHARD]: [
        {
            threshold: 0.1,
            thresholdOperator: '<'
        },
        {
            threshold: 0.15,
            thresholdOperator: '<'
        },
        {
            threshold: 0.2,
            thresholdOperator: '<'
        }
    ],
    [RatchetModelsEnum.AMF_CONVERSION_SONY]: [
        {
            threshold: 0.1,
            thresholdOperator: '<'
        },
        {
            threshold: 0.15,
            thresholdOperator: '<'
        },
        {
            threshold: 0.2,
            thresholdOperator: '<'
        }
    ],
    [RatchetModelsEnum.AMF_CONVERSION_WMG]: [
        {
            threshold: 0.12,
            thresholdOperator: '<'
        },
        {
            threshold: 0.17,
            thresholdOperator: '<'
        },
        {
            threshold: 0.22,
            thresholdOperator: '<'
        }
    ],
    [RatchetModelsEnum.AMF_REVSHARE_CONVERSION_UMG]: [
        {
            threshold: 0.19,
            thresholdOperator: '>=',
            rate: 0.52
        }
    ]
};

/**
 * Groups conversion models by ratchet model name. These are generally 1 to 1,
 * but Prime WMG needs to group primary/secondary/secondary guardrail/tertiary together
 * and Prime UMG needs to group floor/guardrail together
 */
export const groupConversionModels = (conversionModels: RatchetModels): Record<string, RatchetModels> => {
    return (
        conversionModels
            // AMF_REVSHARE_CONVERSION_UMG ratchet model should only be paired with AMF_CONVERSION_UMG
            .filter((ratchetModel) => ratchetModel.ratchetModel !== RatchetModelsEnum.AMF_REVSHARE_CONVERSION_UMG)
            .reduce(
                (accumulator, current) => {
                    // If WMG, group primary/secondary/secondary guardrail/tertiary together
                    const isPrimeWmg = COMBINED_PRIME_WMG_CONVERSION_MODELS.includes(
                        current.ratchetModel as RatchetModelsEnum
                    );
                    // If UMG, group floor/guardrail together
                    const isPrimeUmgFloor = COMBINED_PRIME_UMG_FLOOR_CONVERSION_MODELS.includes(
                        current.ratchetModel as RatchetModelsEnum
                    );

                    const ratchetModelName = isPrimeWmg
                        ? PRIME_COMBINED_CONVERSION_WMG
                        : isPrimeUmgFloor
                          ? PRIME_COMBINED_CONVERSION_UMG
                          : current.ratchetModel!;
                    const ratchetModelValue = (accumulator[ratchetModelName] ?? []).concat(current);

                    return {
                        ...accumulator,
                        [ratchetModelName]: ratchetModelValue
                    };
                },
                {} as Record<string, RatchetModels>
            )
    );
};
